import { useDispatch, useGlobal, useState } from "reactn";
import { validateEmail } from "lib/forms";
import { pathOr } from "lib/functions";

export const useLoginModalTicket = ({
	onClose,
	getReservation,
	blockreservation,
	handleMeet,
	isRutRequired,
	setIsRutModalVisible,
}) => {
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);
	const doLoginWithPass = useDispatch("doLoginWithPass");
	const [forms] = useGlobal("forms");
	const meta = pathOr({}, ["payload"], forms);

	const logIn = ({ email, password }) => {
		setError(null);
		if (!validateEmail(email)) {
			setError({
				EmailMessage: "Ingrese un Email valido",
			});
			const clearError = () => setError(null);
			return setTimeout(clearError, 4000);
		}
		if (!password || password.length < 7) {
			setError({
				passwordMessage:
					"La contraseña debe tener mas de 7 caracteres.",
			});
			const clearError = () => setError(null);
			return setTimeout(clearError, 4000);
		}
		setLoading(true);
		doLoginWithPass({ email, password })
			.then((state) => {
				setSuccess(true);
				setLoading(false);
				onClose();
				if (!state.user.phone || !state.user.rut) {
					if (isRutRequired) {
						return setIsRutModalVisible(true);
					}
				}

				if (getReservation && blockreservation) {
					getReservation(blockreservation, handleMeet(), meta);
					return false;
				}
				// if (getReservation) {
				// 	getReservation();
				// 	return false;
				// }
			})
			.catch((debug) => {
				setLoading(false);
				setError({
					EmailMessage:
						"El Email o la contraseña son incorrectos por favor inténtalo de nuevo.",
					debug,
				});
				const clearError = () => setError(null);
				return setTimeout(clearError, 4000);
			});
	};

	return [logIn, success, loading, error];
};
